<template>
    <div class="sign-in">
        <div class="wrapper">
            <img
                class="logo"
                :src="require('@/assets/moodmix-logo.png')"
            />

            <form class="form" @submit.prevent="signIn()">
                <div class="username-wrapper">
                    <span class="label">Email</span>
                    <input
                        v-model="username"
                        class="username"
                        :class="{'error' : signInError}"
                        type="text"
                        placeholder="Email or Username"
                        required
                    >
                    <p class="error" v-if="signInError">{{ signInError }}</p>
                </div>
            
                
                <span class="label">Password</span>
                <div class="password-wrapper">
                    <input
                        v-model="password"
                        class="password"
                        :type="showPass ? 'text' : 'password'"
                        placeholder="Password"
                        required
                    >
                    <p @click="showPass = !showPass">{{ showPass ? 'Hide' : 'Show' }}</p>
                </div>
            

                <router-link 
                    class="link"
                    :to="{ name: 'ForgotPassword' }"
                >
                    Forgot Password
                </router-link>

                <button class="login" type="submit" :disabled="loading">Login</button>
            </form>

            <!-- <v-facebook-login
                app-id="1780136745474663"
                version="v9.0"
                @login="loginFb"
                @sdk-init="sdkLoad"
                :disabled="loading"
            ></v-facebook-login> -->

            <button class="apple" @click="loginApple">
                <img 
                    class="ios-icon"
                    :src="require('@/assets/ios-icon.png')" alt="apple logo"
                >
                Continue with Apple
            </button>

            <router-link 
                class="link signup"
                :to="{ name: 'SignUp' }"
            >
                Create upmood account
            </router-link>

            <router-link
                class="link terms"
                to="/terms"
                target="_blank"
            >
                Terms and condition apply
            </router-link>
            
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import { mapState } from 'vuex'
// import VFacebookLogin from 'vue-facebook-login-component'

export default {
	data () {
		return {
			username: '',
			password: '',
			showPass: false,
			FB: null,
		}
	},
    
	// components: {
	// 	VFacebookLogin
	// },
    
	computed: {
		...mapState({
			loading: state => state.loading,
			signInError: state => state.signInError,
		})
	},
    
	created () {
		window.AppleID.auth.init({
			clientId : 'com.upmood.moodmix',
			scope : 'name email',
			redirectURI: process.env.VUE_APP_BASE_URL,
			usePopup : true //or false defaults to false
		})
	},

	methods: {
		signIn () {
			this.$store.dispatch('signIn', {
				username: this.username,
				password: this.password
			})
		},
        
		sdkLoad ({FB}) {
			this.FB = FB
		},
        
		// async loginFb () {
		// 	await this.FB.api('/me', 'GET', { fields: 'id,name,email' },
		// 		async res => {
		// 			if (res.error) return
                    
		// 			await this.FB.logout()
		// 			this.$store.dispatch('signInFb', {
		// 				facebook_id: res.id,
		// 				email: res.email,
		// 				name: res.name
		// 			})
		// 		}
		// 	)
		// },
        
		async loginApple () {
			try {
				const data = await window.AppleID.auth.signIn()
				if (data.user) Cookies.set('apple_name', data.user.name.firstName + ' ' + data.user.name.lastName)
                
				await this.$store.dispatch('signInApple', {
					name: data.user ? data.user.name.firstName + ' ' + data.user.name.lastName : Cookies.get('apple_name'),
					jwt: data.authorization.id_token
				})
			} catch ( error ) {
				console.log(error)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.sign-in {
    padding-top: 55px;

    .wrapper {
        display: flex;
        flex-direction: column;
        margin: auto;
        width: 400px;

        @include mobile {
            width: 300px;
        }

        .logo {
            width: 123px;
            height: 61px;
            margin: 0 auto 35px;
        }

        .form {
            display: flex;
            flex-direction: column;

            .label {
                color: #ffffff;
                margin-bottom: 10px;
            }

            .username-wrapper {
                display: flex;
                flex-direction: column;
                margin-bottom: 35px;

                p {
                    text-align: right;
                    color: #F4949A;
                    font-size: 12px;
                }
            }

            .password-wrapper {
                position: relative;

                .password {
                    width: 100%;
                    padding-right: 45px;
                }

                p {
                    color: #BFCCE2;
                    position: absolute;
                    top: 7px;
                    right: 10px;
                    cursor: pointer;
                }
            }

            input {
                padding: 5px;
                border: 1px solid #BFCCE2;
                border-radius: 3px;
                opacity: 1;
                margin-bottom: 5px;
                height: 32px;

                &::placeholder {
                    opacity: 1;
                    color: #BFCCE2;
                    font-size: 12px;
                }
            }
        }

        .link {
            color: #47CBBF;
            text-align: right;
            font-size: 14px;
            margin-bottom: 60px;

            &.signup {
                font-size: 16px;
                text-align: center;
            }

            &.terms {
                text-align: center;
                font-size: 14px;
            }
        }

        button {
            height: 35px;
            width: 242px;
            padding: 8px 0;
            border-radius: 5px;
            margin: 0px auto 35px;
            display: flex;
            justify-content: center;

            &.fb {
                background-color: #2D67C4;
            }
            
            &.apple {
                background-color: #000000;
                margin-bottom: 60px;
            }

            .ios-icon {
                height: 15px;
                width: 15px;
                margin-right: 1.25ch;
            }
        }
    }
}
</style>